import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import { notification, Button } from "antd"
import React from "react"
import { L } from "@lib/abpUtility"

const CHECK_INTERVAL_MS = 5 * 60 * 1000 // Kiểm tra tối đa mỗi 5 phút
const NOTIFICATION_KEY = "new-version-available"

let deployedVersion: string | null = null

// Lần đầu load app, lưu lại version hiện tại làm baseline
const initCurrentVersion = async () => {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" })
    const data = await res.json()
    deployedVersion = data.version ?? null
  } catch {
    // Bỏ qua nếu không fetch được (dev mode hoặc mạng lỗi)
  }
}

initCurrentVersion()

export function useVersionCheck() {
  const location = useLocation()
  const lastCheckRef = useRef<number>(0)

  useEffect(() => {
    const check = async () => {
      // Nếu chưa có version baseline thì bỏ qua
      if (!deployedVersion) return

      const now = Date.now()
      if (now - lastCheckRef.current < CHECK_INTERVAL_MS) return
      lastCheckRef.current = now

      try {
        const res = await fetch(`/version.json?t=${now}`, { cache: "no-store" })
        const data = await res.json()
        const latestVersion: string = data.version

        if (latestVersion && latestVersion !== deployedVersion) {
          // Chỉ show notification 1 lần, không spam
          notification.info({
            key: NOTIFICATION_KEY,
            message: L("NEW_VERSION_AVAILABLE"),
            description: L("NEW_VERSION_DESCRIPTION"),
            btn: React.createElement(
              Button,
              {
                type: "primary",
                size: "small",
                onClick: () => {
                  // Hard navigate + cache-bust để tránh soft reload giữ asset/config cũ sau deploy
                  const url = new URL(window.location.href)
                  url.searchParams.set("_v", String(Date.now()))
                  window.location.href = url.toString()
                },
              },
              L("RELOAD_NOW")
            ),
            duration: 0, // Không tự đóng
          })
        }
      } catch {
        // Bỏ qua nếu không fetch được
      }
    }

    check()
  }, [location.pathname])
}
